@use "variables" as *;

.passkeyCard {
  margin: $spacing-s;
  border-radius: 4px;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.description {
  font-size: $fontSize-s;
  padding: 0 $spacing-xl;
}

.contentCard {
  position: relative;
  margin: $spacing-m;
  overflow: auto !important;
  height: 76vh;
}

.cardContainer {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.searchBar {
  justify-content: center;
}
